import formatErrors from '../../../functions/formatErrors';
import {
    ADD_PREFERENCES,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_FILTERS,
    RESET_ROLE,
    RoleActionTypes,
    SET_ERRORS,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES as SET_ROLE_PREFERENCES,
    SET_ROLE,
    SET_ROLE_DELETE,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_DOCUMENTATION_ACCESS,
    UPDATE_DOCUMENTATION_ONLY,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_IS_ADMIN,
    UPDATE_NAME,
    UPDATE_NAME_LOCALE,
    SET_COLUMNS
} from './actionTypes';
// Types
import { Column } from '../objects/column';
import { RoleState } from '../objects/roleState';
import { Preferences } from '../../profile/objects/preferences';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';

const initialState: RoleState = {
    columns: [{
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }],
    count: 0,
    create: false,
    created_date: null,
    creator: null,
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    id: null,
    is_admin: false,
    documentation_only: false,
    documentation_access: false,
    last_author: null,
    limit: 50,
    list: null,
    modified_date: null,
    name: '',
    name_error: '',
    name_locales: {},
    order: 'asc',
    order_by: 'name',
    page: 0,
    preferences: [],
    refresh: false,
    role: null,
    role_delete: null,
    running: false,
    search: ''
};

export default (state: RoleState = initialState, action: RoleActionTypes | ProfileActionTypes): RoleState => {
    switch (action.type) {
        case ADD_PREFERENCES: {
            return {...state, preferences: [...state.preferences, ...action.payload]};
        }
        case MOVE_DOWN_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload + 1]};
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case MOVE_UP_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload - 1]};
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_period: 'CREATION',
                filter_period_type: 0
            };
        }
        case RESET_ROLE: {
            return {...state, create: false, role: null, name: '', is_admin: false, documentation_only: false, documentation_access: false, name_locales: {}};
        }
        case SET_ERRORS: {
            const { name } = action.payload;
            return {
                ...state,
                name_error: name ? Array.isArray(name) ? formatErrors(name) : name : ''
            };
        }
        case SET_LIMIT: {
            return {...state, list: null, limit: action.payload};
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return {...state, count: count, list: results, running: false};
        }
        case SET_ORDER_BY: {
            return {...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return {...state, list: null, page: action.payload};
        }
        case SET_PREFERENCES: {
            const preferences = action.payload;
            let new_columns: Column[] = [];
            let new_order_by = 'first_name';
            let new_order: 'asc' | 'desc' = 'asc';
            let field_name: string[] = [];
            let role_preferences: Preferences[] = [];
            preferences.map(preference => {
                if (preference.module === 'ROLE') {
                    if (!field_name.includes(preference.field_name)) {
                        switch (preference.field_name) {
                            case 'NAME':
                                new_columns.push({label: 'name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'name' : new_order_by;
                                break;
                            case 'CREATED_DATE':
                                new_columns.push({label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'created_date' : new_order_by;
                                break;
                            case 'CREATED_BY':
                                new_columns.push({label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'creator__username' : new_order_by;
                                break;
                            case 'MODIFIED_DATE':
                                new_columns.push({label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'modified_date' : new_order_by;
                                break;
                            case 'MODIFIED_BY':
                                new_columns.push({label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'last_author__username' : new_order_by;
                                break;
                            default:
                                break;
                        }
                        role_preferences.push(preference);
                        field_name.push(preference.field_name);
                        new_order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : new_order;
                    }
                }
            });
            if (new_columns.length !== state.columns.length) {
                state.columns.map(column => {
                    let added = false;
                    for (let i = 0; i < new_columns.length; i++) {
                        if (new_columns[i].label === column.label) {
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        new_columns.push({...column});
                    }
                });
            }
            return {...state, preferences: role_preferences, columns: new_columns, order_by: new_order_by, order: new_order};
        }
        case SET_ROLE: {
            let name_locales: {} & {[index: number]: any} = {};
            let has_french = false;
            action.payload.localization.map(locale => {
                if (locale.locale === 1) {
                    has_french = true;
                }
                name_locales[locale.locale] = locale.localized_name;
            });
            if (!has_french) {
                name_locales['1'] = action.payload.name !== null ? action.payload.name : '';
            }
            return {...state, role: action.payload, name: action.payload.name, name_locales: name_locales, is_admin: action.payload.is_admin, documentation_only: action.payload.documentation_only, documentation_access: action.payload.doc_access};
        }
        case SET_ROLE_DELETE: {
            if (action.payload === null && state.role_delete !== null && state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === state.role_delete.id) {
                        list.splice(i, 1);
                        return {...state, role_delete: action.payload === false ? null : action.payload, list: list, count: state.count - 1};
                    }
                }
            }
            return {...state, role_delete: action.payload === false ? null : action.payload};
        }
        case SET_ROLE_PREFERENCES: {
            return {...state, preferences: action.payload};
        }
        case SET_RUNNING: {
            return {...state, running: action.payload};
        }
        case SET_SEARCH: {
            return {...state, list: null, page: 0, search: action.payload};
        }
        case TOGGLE_COLUMN: {
            let columns = [...state.columns];
            let column = {...columns[action.payload]};
            column.checked = !column.checked;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case TOGGLE_CREATE: {
            return {...state, create: !state.create};
        }
        case TOGGLE_FILTERS: {
            return {...state, filter_open: !state.filter_open};
        }
        case TOGGLE_REFRESH: {
            return {...state, refresh: !state.refresh};
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return {...state, filter_created_date_gte: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return {...state, filter_created_date_lte: action.payload};
        }
        case UPDATE_FILTER_CREATOR: {
            return {...state, filter_creator: action.payload};
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return {...state, filter_last_author: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return {...state, filter_modified_date_gte: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return {...state, filter_modified_date_lte: action.payload};
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return {...state, filter_period_type: action.payload};
        }
        case UPDATE_NAME: {
            return {...state, name: action.payload};
        }
        case UPDATE_IS_ADMIN: {
            return {...state, is_admin: action.payload};
        }
        case UPDATE_DOCUMENTATION_ONLY: {
            return {...state, documentation_only: action.payload};
        }
        case UPDATE_DOCUMENTATION_ACCESS: {
            return {...state, documentation_access: action.payload};
        }
        case UPDATE_NAME_LOCALE: {
            const { id, value } = action.payload;
            const name_locales = {...state.name_locales};
            name_locales[id] = value;
            return {...state, name_locales: name_locales};
        }
        case SET_COLUMNS: {
            return {...state, columns: action.payload};
        }
        default:
            return state;
    }
};